export const GetLocalStorage = (strName) => {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && localStorage[strName]) {
        strItem = localStorage.getItem(strName);
    }

    return strItem;
};

export const SetLocalStorage = (strName, strValue) => {
    if (typeof (Storage) !== 'undefined') {
        localStorage.setItem(strName, strValue);
    }
};

export const GetSessionStorage = (strName) => {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && sessionStorage[strName]) {
        strItem = sessionStorage.getItem(strName);
    }

    return strItem;
};

export const SetSessionStorage = (strName, strValue) => {
    if (typeof (Storage) !== 'undefined') {
        sessionStorage.setItem(strName, strValue);
    }
};

export const ElementInViewport = (objElement) => {
    //special bonus for those using jQuery
    if (objElement instanceof jQuery) {
        objElement = objElement[0];
    }

    var top = objElement.offsetTop;
    var left = objElement.offsetLeft;
    var width = objElement.offsetWidth;
    var height = objElement.offsetHeight;
    while (objElement.offsetParent) {
        objElement = objElement.offsetParent;
        top += objElement.offsetTop;
        left += objElement.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
};

export const hasClickEvent = element => undefined != element.onclick;

// This is a functions that scrolls to #{blah}link
export const GoToByScroll = (id) => {
    // Remove "link" from the ID
    id = id.replace("#", "");
    // Scroll
    $('html,body').animate({
            scrollTop: $("#" + id).offset().top - $("div#fixedHeader").outerHeight(),
        },
        'fast');
};